import { BaseContainerModel } from '../base-container.model';
import { bl_cms_website_user_agreement_consent_history_RowClass, bl_cms_website_user_agreement_document_hdr_RowClass } from '../../dbschema';

export class UserAgreementConsentHistoryContainerModel extends BaseContainerModel {
    bl_cms_website_user_agreement_consent_history: bl_cms_website_user_agreement_consent_history_RowClass = new bl_cms_website_user_agreement_consent_history_RowClass();
}
